<template>
  <form @submit.prevent="search()">
    <input type="text" required v-model="words"
           class="form-control rounded-pill w-50 custom-padding mx-auto text-center" placeholder="جست و جو">
  </form>
</template>

<script>
import router from "@/router";

export default {
  name: "SearchInput3",
  data() {
    return {
      words: '',
      type: 'product',
    }
  },
  methods: {
    search() {
      console.log('asd')
      router.push({name: 'Search', params: {words: this.words, type: this.type}})
    }
  },
}
</script>

<style scoped>
.custom-padding {
  padding: 27px 0;
}
</style>